import {checkIfMatchParticipant} from '../matches/checkIfMatchParticipant.js';

/**
 * Кому и в каком виде отдается запись матча (GET /api/matches/:matchId/actions).
 *
 *  FULL      — запись как есть, со скрытыми признаками ботов: только админу.
 *              Ему же — записи обучения и локальных партий (инструмент
 *              разбора, где игроки их бросают).
 *  PUBLIC    — запись сетевого матча без скрытых признаков ботов (см.
 *              hideBotMarksInRecordingActions): участнику этого матча и
 *              видеомейкеру (ему открыта запись любого сетевого матча).
 *  FORBIDDEN — всем остальным.
 *
 * Раньше это правило жило только на клиенте (кнопка в деталях матча), а
 * сервер отдавал запись сетевого матча любому вошедшему.
 */
export const MATCH_RECORDING_ACCESS = Object.freeze({
  FULL: 'full',
  PUBLIC: 'public',
  FORBIDDEN: 'forbidden',
});

/**
 * @param {Object} params
 * @param {Object|null} params.match - документ матча (может не быть: запись
 *   без карточки матча остается только при сбое ее сохранения)
 * @param {Object|null} [params.recording] - запись матча, если уже загружена:
 *   признак обучения или локальной партии бывает и только у нее
 * @param {string|null} params.viewerId
 * @param {boolean} params.isViewerAdmin
 * @param {boolean} params.isViewerVideoMaker
 * @returns {string} значение MATCH_RECORDING_ACCESS
 */
export const resolveMatchRecordingAccess = ({
  match = null,
  recording = null,
  viewerId = null,
  isViewerAdmin = false,
  isViewerVideoMaker = false,
}) => {
  if (isViewerAdmin) {
    return MATCH_RECORDING_ACCESS.FULL;
  }
  // Записи обучения и локальных партий не смотрят ни сам игрок, ни видеомейкер
  const isRecordedRun = Boolean(match?.isTutorial || match?.isLocal || recording?.isTutorial || recording?.isLocal);
  if (isRecordedRun) {
    return MATCH_RECORDING_ACCESS.FORBIDDEN;
  }
  if (isViewerVideoMaker || checkIfMatchParticipant(match, viewerId)) {
    return MATCH_RECORDING_ACCESS.PUBLIC;
  }
  return MATCH_RECORDING_ACCESS.FORBIDDEN;
};
